import { bind } from 'hyperhtml/umd';

const createMountFn = () => {
  const boundOutlets = new Map();

  // TODO: We may want to extract this for re-use, perhaps in `app-shell`.
  return outlet => component => {
    const html =
      boundOutlets.get(outlet) ||
      boundOutlets.set(outlet, bind(outlet)).get(outlet);

    return typeof component === 'function'
      ? component(html)
      : html`
          ${component}
        `;
  };
};

export default createMountFn;
